import { Route, Routes } from "react-router-dom";
import Box from "@mui/material/Box";
import { MainPage } from "./main";
import { TeamGrid, TeamPage } from "./teams";
import { Header } from "widgets";
import { Container, LinearProgress } from "@mui/material";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";

export const Routing = () => {
  const {
    data: roles,
    isLoading,
    isUninitialized,
    isError,
  } = useGetMyRolesQuery();

  if (isLoading || isUninitialized || isError) {
    return <LinearProgress />;
  }

  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Header />
      <Container maxWidth="xl" sx={{ height: "100%" }}>
        {roles.toString().includes("staffdesk") ? (
          <Routes>
            <Route path="*" element={<MainPage />} />
            <Route path="/teams" element={<TeamPage />} />
            <Route path="/teams/:id/*" element={<TeamGrid />} />
          </Routes>
        ) : (
          <Box pt={2.5}>
            У тебя нет доступа к штатке, обратись к команде CSA
          </Box>
        )}
      </Container>
    </Box>
  );
};
